const apiUrl = '';
export default {
	banUrl: window.location.protocol + '//' + window.location.host + '/zhjrfw/',
	//图片资源
	picUrl: window.location.protocol + '//' + window.location.host + '/zhjrfw/resource/',
	//统一认证
	// confirmUrl: 'http://61.190.70.197:8800/uccp-user/resources/appSystem/login/login-select.html?callback=http://112.30.107.13:20010/zhjrfw/mobile/index.html#/mineList&appCode=test_123'
	confirmUrl: 'https://sso.ahzwfw.gov.cn/uccp-user/resources/appSystem/login/login-select.html?callback=http://www.hsjrfw.com/mobile/index.html#/mineList&appCode=e29e7b0c19de4420bbf4e9c17b04b403'
};


//////////////////
// WEBPACK FOOTER
// ./config/api.js
// module id = IYyn
// module chunks = 11